<template>
  <div>
    <div>form goes here</div>
      <address-book-form
        v-on:save="save"
        :payload="payload">
      </address-book-form>
      <div><button @click="clear">Clear</button></div>
    <div>
      My Addresses
      <ul>
        
        <li v-for="(address, index) in addresses" :key="index">
          <div>
            <div>Name: {{ address.first_name }} {{ address.last_name }}</div>
            <div>Address Line 1:{{ address.line_1 }}</div>
            <div>Address Line 2:{{ address.line_2 }}</div>
            <div>Suburb, City: {{ address.suburb }} {{ address.city }}</div>
            <div>Post Code: {{ address.post_code }}</div>
            <div>
              <a @click="edit(index)">Edit</a> | <a @click="remove(index)">Delete</a>
            </div>
          </div>
        </li>
        
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: Number
    },
    
    data() {
      return {
        
        addressId: 0,
        
        payload: {
          first_name: null,
          last_name: null,
          phone: null,
          email: null,
          line_1: null,
          line_2: null,
          suburb: null,
          city: null,          
          post_code: null
        },
        
        loading: false,
        
        addresses: [],
        
        
      };      
    },
    
    mounted() {
      this.load()
    },
    
    methods: {
      
      clear() {
        this.addressId = 0
        
        this.payload = {
          first_name: null,
          last_name: null,
          phone: null,
          email: null,
          line_1: null,
          line_2: null,
          suburb: null,
          city: null,      
          post_code: null
        }
      },
      
      edit(index) {
        this.clear()
        
        this.addressId = this.addresses[index].id,
        this.payload = {
          first_name: this.addresses[index].first_name,
          last_name: this.addresses[index].last_name,
          phone: this.addresses[index].phone,
          email: this.addresses[index].email,
          line_1: this.addresses[index].line_1,
          line_2: this.addresses[index].line_2,
          suburb: this.addresses[index].suburb,
          city: this.addresses[index].city,
          post_code: this.addresses[index].post_code,   
        }
      },
      
      remove(index) {
        this.clear()
        // style the confirm dialog
        
        if (confirm("Click OK to delete.")) {
          this.loading = true
          
          window.axios.delete('/api/user-addresses/' + this.addresses[index].id)
            .then(response => {
              
              alert('Address has been deleted')
              this.load()
              
            })
            .catch(error => {
              alert(error.response.data.message)
              this.loading = false              
            })
        }
      },
      
      save() {
        this.loading = true
        
        if (this.addressId) {
          window.axios.put('/api/user-addresses/' + this.addressId, this.payload)
            .then(response => {
              alert('Address has been updated')
              this.load()              
            })
            .catch(error => {
              this.loading = false
            })
        } else {
          
          window.axios.post('/api/user-addresses', this.payload)
            .then(response => {
              
              alert('Address has been added')
              
              this.load()
            })
            .catch(error => {
              this.loading = false
            })
        }
      },
      
      load() {
        this.loading = true
        this.clear()
        
        window.axios.get('/api/user-addresses')
          .then(response => {
            
            this.addresses = response.data.data
            this.loading = false
            
          })
          .catch(error => {
            this.loading = false
          })
      },
      
    }
    
  };
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-core/address/Index.vue